/* eslint-disable camelcase */

export type SurveyLocation = 'popover' | 'full_screen' | 'external_link';

export function isPopover(surveyLocation: SurveyLocation): boolean {
  return surveyLocation === 'popover';
}

export function isModal(surveyLocation: SurveyLocation): boolean {
  return surveyLocation === 'full_screen';
}

export function isOffsite(surveyLocation: SurveyLocation): boolean {
  return surveyLocation === 'external_link';
}
